
import BaseFilter from '@/components/filters/Filter';
import SelectPicker, { Option } from '@/components/SelectPicker.vue';

export default BaseFilter.extend({
	components: {
		SelectPicker
	},
	props: {
		value: {
			type: Array as () => string[],
			required: true,
			default: () => []
		},
	},
	computed: {
		searchable(): boolean { return Array.isArray(this.options) && this.options!.length > 10; },
	},
});

